
import { put, call, select, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import config from '../config';
import Cookies from 'js-cookie';

//Action
import { loadingSet } from '../action/uiAction';

var packageJson = require('../../package.json');

function* partnerOperationCheck(action) {
  yield put(loadingSet(true));

  const state = yield select();

  if(state.auth.uic === action.payload.pic) {
    yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'error', duration: 5000, comment: '自身には設定できません'} });
  }
  else {
    const {res, err} = yield call(function(payload) {
      const params = new URLSearchParams();
      params.append('ULIC', Cookies.get('ULIC'));
      params.append('ULPC', Cookies.get('ULPC'));
      params.append('pic', payload.pic);
      params.append('version', packageJson.version);
      return axios.post(config.apiUri + "member/partnerOperationCheckApi.php", params, {
        timeout: 10000
      })
      .then((res) => {
        return {res};
      })
      .catch((err) => {
        return {err};
      })
    }, action.payload);

    if (res) {
      if (res.data.bool) {
        yield put({
          type: "PARTNER_OPERATION_OPEN",
          payload: {
            pic: action.payload.pic,
            menu: action.payload.menu,
            partnerName: res.data.partnerName,
            partnerSex: res.data.partnerSex,
            partnerAttestation: res.data.partnerAttestation,
            partnerStop: res.data.partnerStop,
            memo: res.data.memo,
            isFavorite: res.data.isFavorite,
            favoriteLimit: res.data.favoriteLimit,
            isNondisplay: res.data.isNondisplay,
            isRefusal: res.data.isRefusal,
            isFootprint: res.data.isFootprint,
            footprintMyDelRemain: res.data.footprintMyDelRemain,
          },
        });
      }
    }
    if (err) {
      yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'error', duration: 5000, comment: config.apiErrComment} });
    }
  }

  yield put(loadingSet(false));
}


const saga = [
  takeLatest('PARTNER_OPERATION_CHECK', partnerOperationCheck),
];

export default saga;
